import { Col, Row, Card } from "antd";
import React, { useEffect, useRef } from "react";
import { MatApoyo } from "../Generals";
//import { RenderDocument } from "../Material";
import { useSelector } from "react-redux";
///import { getObjetoAutoridad, getEmisionConvocatoria } from "../../../Generals/autoridadesElectorales";

export default function Lesson3({ data, setLoading, objEntidad, origen }) {
  const isMounted = useRef(true);
  //Se obtiene el Entidad seleccionada del store de redux
  const { idEntidad } = useSelector((state) => state.entidad);

  if(idEntidad!==undefined){
    localStorage.setItem('idEntidad', idEntidad);
  }

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  //función que ontiene los datos de la entidad dependiendo si se visualiza la lección dsde el curso o desde materiales de capacitación
  /*const getDataEntidad = () =>{
    const dataEntidad = origen === 1 ?objEntidad : {idEntidad: idEntidad, entidad: entidad};
    return dataEntidad
  }

  const textSinPartido = () =>{
    // Obtenemos el idEntidad dependiendiendo si estamos viendo la lección desde la sección de materiales de capacitación o desde el curso
    const idEntidadOrigen = origen === 1 ? parseInt(objEntidad.idEntidad) : idEntidad; 
    // Creamos un array con las entidades a las que aplica el texto
    const entidadesSinPartido = [9]
    return entidadesSinPartido.includes(idEntidadOrigen) ? ' o sin partido' : ''
  }*/

  
  return (
    <div className="texto_parrafo">
      <p>
        Esta elección tiene como propósito renovar a los integrantes del Poder Judicial de la Federación, es decir, 
        a las ministras y los ministros de la Suprema Corte de Justicia de la Nación, las magistraturas del Tribunal 
        de Disciplina Judicial, las magistraturas del Tribunal Electoral y de los Tribunales Colegiados, así como a 
        las juezas y jueces de los Juzgados de Distrito, lo que corresponde a 881 cargos, de los cuales la ciudadanía 
        elige 16 a nivel nacional,  15 son por circunscripción y 850 por circuito judicial, en todos se observará la 
        paridad de género.
      </p>
      <p> 
        En la siguiente imagen identifica los cargos que se renovarán en 2025.
      </p>
      
      <p>{data && data.indexOf(1) && <MatApoyo array={[data[1]]} />}</p>
      
      <p>
        El proceso electoral extraordinario de las personas juzgadoras del PJF es el conjunto de actos que ordena la 
        Constitución y la ley electoral y que realizan las autoridades electorales, los Poderes de la Unión y la 
        ciudadanía; estos actos tienen por objeto la renovación periódica de las y los miembros del PJF.
      </p>
      <p>Las etapas que componen el proceso electoral extraordinario de las personas juzgadoras son: </p>
      
      <p>{data && data.indexOf(2) && <MatApoyo array={[data[2]]} />}</p>
      
      <p>
        A continuación, te explicamos qué ocurre en cada una de las etapas del proceso. 
      </p>

      <p><h2 className="subtitlesLesons2">1.	Etapa de Preparación de la elección</h2></p>

      <Row gutter={[16, 24]} justify="center">
        <Col md={5} sm={24} xs={24} className="gutter-row">
         <Card className="card-lesson">
         <p className="text-card-lesson">{data && data.indexOf(3) && <MatApoyo array={[data[3]]} />}</p>
         </Card>
        </Col>
        <Col md={5} sm={24} xs={24} className="gutter-row">
         <Card className="card-lesson">
         <p className="text-card-lesson">{data && data.indexOf(4) && <MatApoyo array={[data[4]]} />}</p>
         </Card>
        </Col>
        <Col md={5} sm={24} xs={24} className="gutter-row">
         <Card className="card-lesson">
            <p className="text-card-lesson">{data && data.indexOf(5) && <MatApoyo array={[data[5]]} />}</p>
         </Card>
        </Col>
      </Row>
      <br></br>
      <Row gutter={[16, 24]} justify="center">
        <Col md={5} sm={24} xs={24} className="gutter-row">
         <Card className="card-lesson">
         <p className="text-card-lesson">{data && data.indexOf(6) && <MatApoyo array={[data[6]]} />}</p>
         </Card>
        </Col>
        <Col md={5} sm={24} xs={24} className="gutter-row">
         <Card className="card-lesson">
         <p className="text-card-lesson">{data && data.indexOf(7) && <MatApoyo array={[data[7]]} />}</p>
         </Card>
        </Col>
      </Row>
      <br></br>
      <div className="div-bordered">
        <p>
          Es importante que sepas que, en las entidades donde se celebren elecciones concurrentes del Poder Judicial 
          Local y Federal, la integración de las casillas seccionales será diferente a la de aquellos donde no hay 
          elección concurrente.
        </p>
        <p>
          En las casillas seccionales con elecciones concurrentes, se designará a <b>nueve</b> personas como funcionarias o 
          funcionarios de mesa directiva de casilla seccional (MDCS): <b>seis</b> como propietarias o propietarios y <b>tres</b> 
          como suplentes generales. Por el contrario, en las casillas seccionales sin elección concurrente, se designará a 
          <b>ocho</b> personas únicamente; <b>cinco</b> propietarias y <b>tres</b> suplentes.
        </p>
        <p>
          En ambos casos se podrá designar a una o un escrutador adicional por cada 1,000 electoras o electores.
        </p>
      </div>
      <br></br>
      <Row>
        <Col span={1}/>
        <Col span={1}>
          VI.
        </Col>
        <Col span={20}>
          <p><b style={{color:"#84ACB6"}}>Promoción de la participación ciudadana.</b> Se promoverá la participación ciudadana en 
          el proceso electoral mediante un micrositio en la página oficial del Instituto, para informar sobre el proceso y 
          candidaturas registradas.</p>
        </Col>
      </Row>
      <Row>
        <Col span={1}/>
        <Col span={1}>
          VII.
        </Col>
        <Col span={20}>
          <p><b style={{color:"#84ACB6"}}>Determinación de cargos a renovar.</b> Para seleccionar los cargos a renovar en la elección extraordinaria de 2025, 
          el Consejo de la Judicatura Federal entregó al Senado de la República un listado con la totalidad de cargos de 
          personas juzgadoras, en el que indicó su circuito judicial, especialización por materia, género, vacancias, renuncias 
          y retiros programados. </p>
          <p>
            El Senado de la República determinó la porción de cargos a elegir en cada circuito judicial considerando en primer 
            término las vacancias, las renuncias y los retiros programados. Los cargos restantes se seleccionaron mediante 
            insaculación pública tomando como base la renovación de la mitad de los correspondientes a cada especialización por 
            materia.
          </p>
        </Col>
      </Row>
      <br></br>
      <p>Para conocer más sobre el tema, revisa el apartado <div className="textoResaltado2" style={{display: "inline"}}>3.3. ¿Qué 
        ocurre durante la etapa de la Preparación de la elección?</div> de tu Guía, la cual puedes encontrar en los materiales 
        de consulta.
      </p>

      <p><h2 className="subtitlesLesons2">2.	Etapa de Convocatoria y postulación de candidaturas</h2></p>

      <p>
        Esta etapa inicia con la publicación de la convocatoria general, emitida por el Senado de la República, 
        y concluye con la remisión del listado de candidaturas al INE. 
      </p>

      <p>El procedimiento se compone por siete etapas, que son:</p>

      <p>{data && data.indexOf(8) && <MatApoyo array={[data[8]]} />}</p>

      <p>Para conocer más sobre el tema, revisa el apartado <div className="textoResaltado2" style={{display: "inline"}}>3.4. ¿Qué 
        ocurre durante la etapa de Convocatoria y postulación de candidaturas?, </div> de tu Guía, la cual puedes encontrar en los materiales 
        de consulta.
      </p>

      <p><h2 className="subtitlesLesons2">3.	Etapa de Jornada Electoral</h2></p>

      <p>La Jornada Electoral se celebrará el primer domingo de junio de 2025 e iniciará a las 8:00 a.m. </p>

      <p>Durante la Jornada Electoral las ciudadanas y los ciudadanos que pueden estar en la casilla seccional son:</p>

      <p>{data && data.indexOf(9) && <MatApoyo array={[data[9]]} />}</p>

      <p>La Jornada Electoral se divide en cinco momentos:</p>

      <p>{data && data.indexOf(10) && <MatApoyo array={[data[10]]} />}</p>
      
      <p>Abre los enlaces que te llevarán a las infografías de cada momento de la Jornada Electoral para conocer las actividades que se llevan a cabo durante esa etapa.</p>
      
      <Row gutter={[16, 24]} justify="center">
        <Col md={5} sm={24} xs={24} className="gutter-row">
         <Card className="card-lesson">
         <p className="text-card-lesson">{data && data.indexOf(11) && <MatApoyo array={[data[11]]} />}</p>
         </Card>
        </Col>
        <Col md={5} sm={24} xs={24} className="gutter-row">
         <Card className="card-lesson">
         <p className="text-card-lesson">{data && data.indexOf(12) && <MatApoyo array={[data[12]]} />}</p>
         </Card>
        </Col>
        <Col md={5} sm={24} xs={24} className="gutter-row">
         <Card className="card-lesson">
            <p className="text-card-lesson">{data && data.indexOf(13) && <MatApoyo array={[data[13]]} />}</p>
         </Card>
        </Col>
      </Row>
      <br></br>
      <Row gutter={[16, 24]} justify="center">
        <Col md={5} sm={24} xs={24} className="gutter-row">
         <Card className="card-lesson">
         <p className="text-card-lesson">{data && data.indexOf(14) && <MatApoyo array={[data[14]]} />}</p>
         </Card>
        </Col>
        <Col md={5} sm={24} xs={24} className="gutter-row">
         <Card className="card-lesson">
         <p className="text-card-lesson">{data && data.indexOf(15) && <MatApoyo array={[data[15]]} />}</p>
         </Card>
        </Col>
      </Row>
      <br></br>

      <p>Las personas con discapacidad (PcD), las adultas mayores y las mujeres embarazadas pueden votar 
        sin necesidad de hacer fila. 
      </p>

      <p>Durante la votación pueden presentarse electoras y electores con una resolución del TEPJF que 
        les autorice a votar sin credencial; en este caso, además de esta resolución, deben mostrar una 
        identificación con fotografía.
      </p>

      <p>El <b>cierre de la votación es a las 6:00 p.m.</b>, sin embargo:</p>

      <ul>
        <li>Se puede cerrar <b>antes</b> si toda la ciudadanía que aparece inscrita en la Lista Nominal de Electores ya votó. </li>
        <li>Se puede cerrar <b>después</b> si hay personas formadas que llegaron a las 6:00 p.m. o antes.</li>
      </ul>

      <p><h2 className="subtitlesLesons2">4.	Etapa de Cómputos y sumatoria</h2></p>

      <p>
        La etapa de Cómputos y sumatoria inicia con la remisión de la documentación y los expedientes electorales 
        a los consejos distritales y concluye con la sumatoria que realice el Consejo General de los cómputos de 
        la elección. 
      </p>
      
      <p>En esta etapa podrás observar las siguientes actividades: </p>

      <p>
        <b>Paso 1.</b> Los consejos distritales realizarán el cómputo de las votaciones de las elecciones de personas 
        juzgadoras.
      </p>
      <p>
        <b>Paso 2.</b> Concluidos los cómputos de cada elección, el Consejo Distrital emitirá a cada candidatura ganadora 
        una constancia de resultados. 
      </p>
      <p>
        <b>Paso 3.</b> Se remitirán al Consejo General las constancias de resultados.
      </p>
      <p>
        <b>Paso 4.</b> El Consejo General realizará la sumatoria de los cómputos de las elecciones.
      </p>

      <p><h2 className="subtitlesLesons2">5.	Etapa de Asignación de cargos</h2></p>

      <p>
        Esta etapa inicia cuando el INE identifica qué candidaturas obtuvieron el mayor número de 
        votos y le asigna a cada una de éstas un cargo en función de su especialización por materia 
        y alternando entre mujeres y hombres, y concluye cuando entrega las constancias de mayoría 
        a las candidaturas que resultan ganadoras y emite la declaración de validez respectiva. 
      </p>
      <p>En esta etapa podrás observar las siguientes actividades: </p>
      <p>
        <b>Paso 1.</b> El INE asigna los cargos por materia de especialización a las candidaturas que hayan 
        obtenido el mayor número de votos, observando la paridad de género.
      </p>
      <p>
        <b>Paso 2.</b>. El INE publica los resultados de la elección.
      </p>

      <p>
        <h2 className="subtitlesLesons2">6.	Etapa de Entrega de constancias de mayoría y declaración de 
        validez de la elección</h2>
      </p>
      <p>
        La etapa de calificación y declaración de validez inicia al resolverse el último de los medios de 
        impugnación que se hubiesen interpuesto en contra de las elecciones respectivas o cuando se tenga 
        constancia de que no se presentó ninguno, y concluye cuando la Sala Superior del TEPJF o la SCJN 
        aprueba el dictamen que contenga el cómputo final de la elección. 
      </p>
      <p>En esta etapa podrás observar las siguientes actividades: </p>
      <p>
        <b>Paso 1.</b> . El Consejo General del INE entregará las constancias de mayoría a las candidatas y 
        los candidatos que obtengan más votos y declarará la validez de la elección.
      </p>
      <p>
        <b>Paso 2.</b> El INE comunicará los resultados a la Sala Superior del TEPJF y a la SCJN, según corresponda.
      </p>
      <p>
        <b>Paso 3.</b> Las candidatas y los candidatos electos tomarán protesta de su cargo ante el Senado 
        de la República el 1° de septiembre de 2025.
      </p>
      <p>
        <b>Paso 4.</b> El Órgano de Administración Judicial adscribirá a las personas electas a los órganos 
        judiciales a más tardar el <b>15 de septiembre de 2025.</b>
      </p>
      <p>
        Una vez que las juezas, los jueces y las magistraturas tomen posesión de sus cargos, su desempeño se 
        evaluará durante el primer año de ejercicio; el TDJ será el encargado de llevarla a cabo.
      </p>
      <p>
        Durante la evaluación, el TDJ revisará que los cargos renovados cumplan con los estándares de desempeño 
        requeridos por la ley y el sistema judicial.
      </p>
      <p>
        Si se detectan problemas o irregularidades, el TDJ podrá aplicar medidas correctivas, que pueden incluir 
        desde advertencias hasta sanciones más severas, como la remoción del cargo en casos graves.
      </p>
      <p>
        Pon a prueba lo que has aprendido realizando esta actividad interactiva. Responde las preguntas, explora 
        las opciones y revisa tus resultados para fortalecer tus conocimientos. ¡Puedes repetirla cuantas veces quieras!
      </p>
      <p>{data && data.indexOf(16) && <MatApoyo array={[data[16]]} />}</p>

      <p>
        Consulta la presentación para encontrar un resumen claro y preciso del tema. Este material te ayudará a 
        complementar tu aprendizaje y a reforzar los conceptos esenciales.
      </p>
      <p>{data && data.indexOf(17) && <MatApoyo array={[data[17]]} />}</p>
      <p>
      Para profundizar tus conocimientos sobre el proceso electoral extraordinario del PJF, revisa 
      el  <div className="textoResaltado2" style={{display: "inline"}}> tema 3 de la </div>
      {data && data.indexOf(18) && <MatApoyo array={[data[18]]} tipo={1}/>}, que está disponible en 
      los materiales de consulta de este curso.
      </p>
      <p>
        Para la observación electoral de las entidades en donde se celebre la elección concurrente de 
        las y los integrantes del Poder Judicial Federal y Local, podrás consultar el 
        <div className="textoResaltado2" style={{display: "inline"}}>tema 2 de la Adenda a la Guía para 
          las y los observadores electorales de cada entidad con elección extraordinaria del Poder 
          Judicial Local en 2025</div>, ahí encontrarás las actividades que se llevan a cabo en las 
          etapas del proceso electoral extraordinario del Poder Judicial Local de cada entidad, así 
          como las particularidades de la integración de las casillas seccionales y los cargos a renovarse. 
          La Adenda está disponible en los materiales de consulta de este curso.
      </p>
      <p>
        Has concluido la lección 3; es momento de evaluar tu aprendizaje. Responde la autoevaluación 
        correspondiente.
      </p>
    </div>
  );
}
